import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "./ui/button";
import { cn } from "@lib/utils";

export default function IconButton (
  {
    icon,
    actionCallback,
    style,
    text
  }
  :
  {
    icon: IconDefinition,
    actionCallback: () => void,
    style?: string,
    text?: string
  }
) {

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="w-fit h-fit p-0 hover:bg-transparent"
      onClick={ (e) => {
        e.stopPropagation();
        actionCallback();
      }}
    >
      {text && <span className="mr-1 hover:underline">{text}</span>}
      <FontAwesomeIcon className={cn(style)} icon={icon} />
    </Button>
  )

}
